module.exports = __webpack_public_path__ + "img/icon-05.7c661073.png";